import * as React from 'react';
import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
  Omit<RouterLinkProps, 'to'> & { href: string };

const Link = React.forwardRef<HTMLAnchorElement, Props>(function Link({ href, ...props }, ref) {
  if (/^(https?:|mailto:|tel:)/.test(href)) return <a ref={ref} href={href} {...props} />;
  return <RouterLink ref={ref} to={href} {...props} />;
});

export default Link;
